<template>
  <div style="width: 100%">
    <v-row>
      <v-col>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-toolbar flat>
                <v-toolbar-title>
                  <h2
                    class="title primary--text text--darken-1 text-no-wrap mt-0"
                  >
                    INDICAÇÕES DE DESENVOLVIMENTO
                  </h2>
                </v-toolbar-title>
              </v-toolbar>
            </v-row>
            <v-row class="justify-center">
              <v-col
                cols="8"
                md="8"
                sm="12"
              >
                <app-indicacao
                  :indicacoes-desenvolvimento="indicacoesDesenvolvimento"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-toolbar flat>
                <v-toolbar-title>
                  <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
                    GRÁFICOS
                  </h2>
                </v-toolbar-title>
              </v-toolbar>
            </v-row>
            <v-row class="justify-center">
              <v-col>
                <v-row class="justify-center">
                  <gauge-chart
                    :dados="dadosGauge"
                    :fonte="`Fonte: Sistema Desenvolva, ${desempenho.diagnostico.ano}`"
                    :maximo="desempenho.notaMaximaResponsabilidade * 10"
                    :minimo="0"
                    class="chart"
                    descricao="Autoavaliação x 40% + Avaliação do Gestor x 60%"
                    descricao-titulo="Resultado do Desempenho Técnico"
                    formato="%"
                    titulo="Resultado do Desempenho Técnico"
                    :is-get-svg="isGetSvg"
                    @svg="(value) => svg = value"
                  />
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="headers"
                  :items="desempenho.resultadosResponsabilidade"
                  :search="opcoes.pesquisa"
                  :sort-by="opcoes.ordenarPor"
                  :sort-desc="opcoes.decrescente"
                  class="elevation-0"
                  disable-pagination
                  hide-default-footer
                  show-expand
                  single-expand
                >
                  <template v-slot:top>
                    <v-row>
                      <v-toolbar flat>
                        <v-toolbar-title>
                          <h2 class="title primary--text text--darken-1 text-no-wrap">
                            RESULTADOS
                          </h2>
                        </v-toolbar-title>
                      </v-toolbar>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="4">
                        <app-sort v-model="opcoes" />
                      </v-col>
                      <v-col cols="0" md="4" />
                      <v-col cols="12" md="4">
                        <app-search v-model="opcoes" />
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.data-table-expand`]="{item, expand, isExpanded}">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          height="100%"
                          text
                          width="100%"
                          @click="
                            expand(!isExpanded);
                            generateColumns(
                              colunas,
                              item.responsabilidade.competencias
                            );
                          "
                          v-on="on"
                        >
                          <v-badge right>
                            <template v-slot:badge>
                              <span>{{ item.responsabilidade.competencias.length }}</span>
                            </template>
                            <v-icon
                              color="grey lighten-0"
                              large
                            >
                              build
                            </v-icon>
                          </v-badge>
                        </v-btn>
                      </template>
                      <span>Clique para exibir as competências técnicas</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td
                      :colspan="headers.length"
                      class="justify-center"
                    >
                      <v-row dense>
                        <v-row class="justify-center">
                          <v-col cols="5">
                            <p>
                              <strong class="primary--text text--darken-1 text-no-wrap">DIFICULDADE:</strong>
                              {{ item.responsabilidade.dificuldade.descricao }}
                            </p>
                          </v-col>
                          <v-col cols="5">
                            <p>
                              <strong class="primary--text text--darken-1 text-no-wrap">IMPACTO:</strong>
                              {{ item.responsabilidade.impacto.descricao }}
                            </p>
                          </v-col>
                        </v-row>
                      </v-row>
                      <v-row>
                        <v-spacer />
                        <v-col>
                          <v-row class="justify-center">
                            <h2 class="title primary--text text--darken-1 text-no-wrap">
                              COMPETÊNCIAS TÉCNICAS
                            </h2>
                          </v-row>
                        </v-col>
                        <v-spacer />
                      </v-row>
                      <v-row>
                        <v-spacer />
                        <v-col cols="10">
                          <v-simple-table class="elevation-0 mb-4" dense>
                            <template v-slot:default>
                              <tbody>
                                <tr
                                  v-for="column in colunas.lista"
                                  :key="column.id"
                                >
                                  <td
                                    v-for="competencia in column"
                                    :key="competencia.nome"
                                    width="30%"
                                  >
                                    <div class="d-flex flex-row ma-1">
                                      <span
                                        :class="
                                          competencia.tipo === 'GERAL'
                                            ? 'secondary--text'
                                            : 'grey-text text--darken-2'
                                        "
                                      >{{ competencia.nome }}</span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-col>
                        <v-spacer />
                      </v-row>
                    </td>
                  </template>
                  <template v-slot:[`item.notaAutoavaliacao`]="{ item }">
                    {{ item.notaAutoavaliacao | decimal }}
                  </template>
                  <template v-slot:[`item.notaGestor`]="{ item }">{{ item.notaGestor | decimal }}</template>
                  <template v-slot:[`item.notaMaxima`]="{ item }">{{ item.notaMaxima | decimal }}</template>
                  <template v-slot:[`item.notaAgrupada`]="{ item }">{{ item.notaAgrupada | decimal }}</template>
                  <template v-slot:[`body.append`]>
                    <tr>
                      <td align="center" colspan="2">
                        <strong class="subtitle-2 grey--text text--darken-2">TOTAL</strong>
                      </td>
                      <td align="center">
                        <strong>{{ desempenho.notaAutoavaliacaoResponsabilidade | decimal }}</strong>
                      </td>
                      <td align="center">
                        <strong>{{ desempenho.notaGestorResponsabilidade | decimal }}</strong>
                      </td>
                      <td align="center">
                        <strong>{{ desempenho.notaMaximaResponsabilidade | decimal }}</strong>
                      </td>
                      <td align="center">
                        <strong>{{ desempenho.notaAgrupadaResponsabilidade | decimal }}</strong>
                      </td>
                    </tr>
                    <v-divider />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="justify-end">
          <v-tooltip
            max-width="400"
            top
          >
            <template v-slot:activator="{ on }">
              <v-btn
                class="mr-4"
                color="success"
                @click="getRelatorio(desempenho)"
                v-on="on"
              >
                <v-icon>get_app</v-icon>
                BAIXAR PDF
              </v-btn>
            </template>
            <span>Clique para baixar o relatório dos dados em formato PDF.</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import GaugeChart from '@/components/chart/GaugeChart';
import { generatePDF, preparePdf, convertSvg } from '@/modules/relatorioPDF';
import { formatNomeArquivo } from '@/modules/texto';
import AppIndicacao from '@/components/core/AppIndicacaoResponsabilidade';
import Data from '@/modules/data';
import toDecimal from '@/filters/decimal';

export default {
  name: 'ResultadoAgrupadoResponsabilidade',

  components: {
    AppSort,
    AppSearch,
    GaugeChart,
    AppIndicacao,
  },

  props: {
    desempenho: {
      type: Object,
      required: true,
    },
    tipo: {
      type: String,
      default: 'AGRUPADO',
      required: true,
    },
    menuAcesso: {
      type: String,
      default: 'DESEMPENHO',
      required: false,
    },
  },

  data() {
    return {
      headers: [
        { text: 'RESPONSABILIDADE', value: 'responsabilidade.titulo', sortable: false },
        {
          text: 'COMPETÊNCIAS',
          value: 'data-table-expand',
          width: '10%',
          align: 'center',
        },
        {
          text: 'NOTA AUTOAVALIAÇÃO',
          value: 'notaAutoavaliacao',
          sortable: false,
          align: 'center',
        },
        {
          text: 'NOTA GESTOR',
          value: 'notaGestor',
          sortable: false,
          align: 'center',
        },
        {
          text: 'NOTA MÁXIMA',
          value: 'notaMaxima',
          sortable: false,
          align: 'center',
        },
        {
          text: 'RESULTADO',
          value: 'notaAgrupada',
          sortable: false,
          align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'responsabilidade.titulo',
        selecionado: { id: 'responsabilidade.titulo', descricao: 'Nome da Responsabilidade' },
        lista: [
          { id: 'responsabilidade.titulo', descricao: 'Nome da Responsabilidade' },
          { id: 'responsabilidade.competencias.length', descricao: 'Número de Competências' },
          { id: 'notaAutoavaliacao', descricao: 'Nota da Autoavaliação' },
          { id: 'notaGestor', descricao: 'Nota da Avaliação do Gestor' },
          { id: 'notaMaxima', descricao: 'Nota Máxima' },
          { id: 'notaAgrupada', descricao: 'Resultado' },
        ],
      },
      colunas: {
        id: '',
        lista: [],
      },
      isGetSvg: false,
      svg: null,
    };
  },

  computed: {
    dadosGauge() {
      return [parseFloat((this.desempenho.notaAgrupadaResponsabilidade * 10).toFixed(2))];
    },
    indicacoesDesenvolvimento() {
      return this.desempenho.resultadosResponsabilidade.filter((r) => r.indicacaoDesenvolvimento);
    },
  },

  methods: {
    generateColumns(columns, itens) {
      columns.id = '';
      columns.lista = [];

      const mid = Math.ceil(itens.length / 3);

      for (let col = 0; col < mid; col += 1) {
        columns.id = col;
        columns.lista.push(itens.slice(col * 3, col * 3 + 3));
      }
    },
    async getRelatorio(desempenho) {
      this.isGetSvg = true;
      await preparePdf(async () => {
        const inicio = Data.format(desempenho.diagnostico.inicioResponsabilidadeChefia);
        const fim = Data.format(desempenho.diagnostico.fimResponsabilidadeServidor);

        const documento = {
          nome: `relatorio-desempenho-responnsabilidade-servidor-${formatNomeArquivo(desempenho.usuario.nome)}-${
            desempenho.diagnostico.id}`,
          cabecalho: {
            titulo: 'Desempenho Técnico do Servidor',
            itens: [
              `Diagnóstico: ${desempenho.diagnostico.nome}`,
              `Período de Avaliação: ${inicio} a ${fim}`,
              `Servidor(a): ${desempenho.usuario.nome}`,
              `Unidade: ${desempenho.unidade.nome} (${desempenho.unidade.sigla})`,
            ],
          },
          blocos: [
            {
              titulo: 'INDICAÇÕES DE DESENVOLVIMENTO',
              itens: [{
                tipo: 'tabela',
                valor: {
                  simples: true,
                  colunas: [
                    'RESPONSABILIDADE',
                    'RESULTADO',
                    'RESULTADO\nMÁXIMO',
                    'Nº DE\nCOMPETÊNCIAS',
                    'TIPO DE\nINDICAÇÃO',
                  ],
                  linhas: [
                    ...this.indicacoesDesenvolvimento.map((i) => [
                      i.responsabilidade.titulo,
                      toDecimal(i.notaAgrupada),
                      toDecimal(i.notaMaxima),
                      i.responsabilidade.competencias.length,
                      'Desenvolvimento',
                    ]),
                  ],
                  customizacoes: [
                    {
                      secao: 'body',
                      colunas: [1],
                      estilos: [
                        {
                          cor: 'error',
                          valores: this.indicacoesDesenvolvimento.map((i) => i.responsabilidade.titulo),
                        },
                      ],
                    },
                  ],
                },
              }],
            },
            {
              titulo: 'GRÁFICOS',
              itens: [
                { tipo: 'imagem', valor: await convertSvg(this.svg), largura: 140 },
              ],
            },
            {
              titulo: 'RESULTADOS',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: ['RESPONSABILIDADE', 'NOTA AUTOAVALIAÇÃO', 'NOTA DO GESTOR', 'NOTA MÁXIMA', 'RESULTADO'],
                  linhas: desempenho.resultadosResponsabilidade.map((r) => [
                    r.responsabilidade.titulo,
                    toDecimal(r.notaAutoavaliacao),
                    toDecimal(r.notaGestor),
                    toDecimal(r.notaMaxima),
                    toDecimal(r.notaAgrupada),
                  ]),
                  rodape: [
                    'TOTAL',
                    toDecimal(desempenho.notaAutoavaliacaoResponsabilidade),
                    toDecimal(desempenho.notaGestorResponsabilidade),
                    toDecimal(desempenho.notaMaximaResponsabilidade),
                    toDecimal(desempenho.notaAgrupadaResponsabilidade),
                  ],
                },
              }],
            },
          ],
        };
        generatePDF(documento);
      });
      this.isGetSvg = false;
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  max-height: 400px;
  font-family: Roboto, sans-serif;
}

.chart-2 {
  max-height: 400px;
  font-family: Roboto, sans-serif;
}
</style>
